import { useEffect, useState } from 'react'

const useVanryData = ({setIsDataFetched}) => {
  const [vanryPrice, setVanryPrice] = useState(null)
  const [marketCap, setMarketCap] = useState('')
  const [priceChangePercentage, setPriceChangePercentage] = useState(null)

  const isDataStale = (timestamp) => {
    const now = new Date()
    const fiveMinutesInMillis = 5 * 60 * 1000
    return now.getTime() - timestamp > fiveMinutesInMillis
  }
  const url = process.env.REACT_APP_VANRY_MCAP_PRICE
  const getChangePercentageUrl = process.env.REACT_APP_VANRY_CHANGEPRC

  const fetchData = async () => {
    try {
      if (url !== undefined && getChangePercentageUrl !== undefined) {
        const response = await fetch(url)
        const getPercentage = await fetch(getChangePercentageUrl)
        const json = await response.json()
        const percJson = await getPercentage.json()
        const vanryData = json.data.filter((d) => d.s === 'VANRYUSDT')
        const mCapInMillions = (vanryData[0]?.c * vanryData[0]?.cs)
          .toLocaleString()
          .split('.')[0]
        setVanryPrice(Number(vanryData[0]?.c))
        const parsedMCapInMillions = Number(mCapInMillions.replace(/,/g, ""));

        setMarketCap(parsedMCapInMillions)
        setPriceChangePercentage(percJson?.priceChangePercent)
        const now = new Date()
        const cacheData = {
          vanryPrice: vanryData[0]?.c,
          priceChangePercentage: percJson?.priceChangePercent,
          marketCap: parsedMCapInMillions,
          timestamp: now.getTime()
        }
        localStorage.setItem('apiData', JSON.stringify(cacheData))
        setIsDataFetched(true)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    setInterval(() => {
      const cachedDataString = localStorage.getItem('apiData')
      if (cachedDataString !== null) {
        const cachedData = JSON.parse(cachedDataString)
        if (!isDataStale(cachedData.timestamp)) {
          setVanryPrice(Number(cachedData.vanryPrice))
          const parsedMCapInMillions = cachedData.marketCap;
          setMarketCap(parsedMCapInMillions)
          setPriceChangePercentage(cachedData?.priceChangePercentage)
          return
        }
      }
      void fetchData()
    }, 300000)
    void fetchData()
  }, [])

  return {
    vanryPrice,
    marketCap,
    priceChangePercentage
  }
}

export default useVanryData
